import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { LICENSES_QUERY_KEY } from "license/hooks/useLicenses";
import { LICENSES_VALIDITY_KEY } from "license/hooks/useLicenseValidityForSubject";
import { ACTIVE_LICENSE_QUERY_KEY } from "license/hooks/useActiveLicenseInformation";
const saveLicense = async (token) => SystemLicenses.uploadLicense(token);
const verifyLicense = async (token) => SystemLicenses.verifyLicense(token);
const deleteLicense = async ({ licenseId, contractId }) => SystemLicenses.deleteLicense(licenseId, contractId);
const useLicenseMutation = () => {
  const queryClient = useQueryClient();
  const save = useMutation({
    mutationFn: saveLicense,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.save_failed", { ns: "enterprise_license", error: errorThrown }),
        i18n.t("notifications.save_failed_title", { ns: "enterprise_license" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.save_success", { ns: "enterprise_license" }),
        i18n.t("notifications.success_title", { ns: "enterprise_license" })
      );
      queryClient.invalidateQueries({
        queryKey: [LICENSES_VALIDITY_KEY]
      });
      queryClient.refetchQueries({ queryKey: [LICENSES_QUERY_KEY], type: "active" });
      return queryClient.refetchQueries({ queryKey: [ACTIVE_LICENSE_QUERY_KEY], type: "active" });
    }
  });
  const verify = useMutation({
    mutationFn: verifyLicense,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.verify_failed", { ns: "enterprise_license", error: errorThrown }),
        i18n.t("notifications.verify_failed_title", { ns: "enterprise_license" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.verify_success", { ns: "enterprise_license" }),
        i18n.t("notifications.success_title", { ns: "enterprise_license" })
      );
    }
  });
  const remove = useMutation({
    mutationFn: deleteLicense,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.delete_failed", { ns: "enterprise_license", error: errorThrown }),
        i18n.t("notifications.delete_failed_title", { ns: "enterprise_license" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.delete_success", { ns: "enterprise_license" }),
        i18n.t("notifications.success_title", { ns: "enterprise_license" })
      );
      queryClient.invalidateQueries({
        queryKey: [LICENSES_VALIDITY_KEY]
      });
      queryClient.refetchQueries({ queryKey: [LICENSES_QUERY_KEY], type: "active" });
      return queryClient.refetchQueries({ queryKey: [ACTIVE_LICENSE_QUERY_KEY], type: "active" });
    }
  });
  return {
    saveLicense: save.mutateAsync,
    verifyLicense: verify.mutateAsync,
    deleteLicense: remove.mutateAsync
  };
};
export default useLicenseMutation;
